import Container from '@mui/material/Container';
import type { ComponentProps } from 'react';

type Props = Pick<ComponentProps<typeof Container>, 'children'> & {
  sx?: ComponentProps<typeof Container>['sx'];
};

export const MobileLayout = ({ children, sx }: Props) => {
  return (
    <Container maxWidth="sm" sx={{ py: 4, ...sx }}>
      {children}
    </Container>
  );
};
